class CurrentMachine extends HTMLElement {
  #noMachineText = this.querySelector('[data-no-machine-text]');
  #machineText = this.querySelector('[data-machine-text]');
  #parentSection = this.closest('section');
  #stickyContainer = this.querySelector('[data-sticky-container]');

  connectedCallback() {
    const machineController = window.getMachineController?.();
    const state = machineController.getCurrentState();
    this.updateDisplayText(state.brand, state.model);
    this.initSectionHeight();
    subscribe('machine:change', (machineData) => {
      this.updateDisplayText(machineData.brand, machineData.model);
    });
  }

  updateDisplayText(brand, model) {
    if (brand && model) {
      this.#machineText.textContent = `${brand}  ${model}`;
      this.showElement(this.#machineText);
      this.hideElement(this.#noMachineText);
    } else {
      this.showElement(this.#noMachineText);
      this.hideElement(this.#machineText);
    }
    this.classList.remove('hidden');
  }

  hideElement(element) {
    element.classList.add('hidden');
    element.ariaHidden = true;
  }

  showElement(element) {
    element.classList.remove('hidden');
    element.ariaHidden = false;
  }

  // We set the CSS variable so the potential background element can be properly positioned.
  initSectionHeight() {
    if (!this.#stickyContainer) return;
    const height = this.#stickyContainer.offsetHeight;
    this.#parentSection.style.setProperty('--sticky-size', `${height}px`);
  }
}

customElements.define('current-machine', CurrentMachine);
